module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/logo_ravdanew.430df08d.png";